import {
  getStageStatusColor,
  STAGE_STATUS_TEXT,
} from "@/features/assignment/lib";
import { StageStatus } from "@/shared/api";
import { Badge, Box, Flex, Text } from "@radix-ui/themes";

export function StageStatusItem({
  label,
  value,
}: {
  label: string;
  value: StageStatus;
}) {
  return (
    <Flex align="center" justify="between" gap="1">
      <Text size="1" color="gray" className="capitalize">
        {label.split("_").join(" ")}
      </Text>
      <Box>
        <Badge color={getStageStatusColor(value)}>
          {STAGE_STATUS_TEXT[value] || value}
        </Badge>
      </Box>
    </Flex>
  );
}
